<template>
  <div class="filter-widget">
    <h2 class="widget-title toggle-item" :class="{active: active}" @click="active=!active"><span></span>{{$t("shop.sidebar."+filter.title)}}</h2>
    <div class="widget-listing-box" v-show="['md', 'lg', 'xl', 'hd', 'inf'].includes($mq) || active">
      <vue-slider
        v-model="filter.value"
        v-on:drag-end="change_price()"
        :min="filter.limits[0]"
        :max="filter.limits[1]"
      ></vue-slider>
      <div class="selected-prices">
        <div>{{ filter.value[0] }} AMD</div>
        <div>{{ filter.value[1] }} AMD</div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
export default {
  components: {
    VueSlider
  },
  i18n: {
    messages: {
      en: {
        price: 'Price'
      },
      hy: {
        price: 'Գին'
      }
    }
  },
  props: ['filter'],
  data () {
    return {
      active: false
    }
  },
  methods: {
    change_price () {
      this.$parent.set_query(this.filter.value.join(','), 'price')
    }
  }
}
</script>
